<template>
  <div class="input-card">
    <div class="input-item">
      <!--  <button class="btn" @click="addMakerTest()" :disabled="isAddMarkers">显示点位信息</button> -->
      <!--  <button class="btn" @click="delMakerTest()" :disabled="isAddMarkers">添加光点</button> -->
      <!--   <button class="btn" @click="addRoutes()" :disabled="isAddRoute">添加随机路径动画</button> -->
    </div>
    <!--  <div class="input-item">
      <button class="btn" @click="vectorStyleFillExtrusion()" :disabled="isFillExtrusion">矢量数据图层拉伸</button>
      <button class="btn" @click="vectorStyleQueryAddMesh()" :disabled="isAddMesh">查询数据并绘制物件</button>
    </div> -->
  </div>
</template>

<script>
import vjmap from 'vjmap'
import TextMarker from "@/components/vjmapUtil/TextMarker";
import Vue from "vue";
import service from '../../service/leftService';
export default {
  name: "ToolBar",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    TextMarker
  },
  data() {
    return {
      isAddMarkers: false,
      isAddRoute: false,
      isFillExtrusion: false,
      isAddMesh: false,
      humd: '0.00',
      pointZhou: [{ "x": 3156554.34, y: 129160.016, z: undefined }, { x: 3153041.49, y: 120816.942, z: undefined }, { x: 3167784.16, y: 120919.343, z: undefined }, { x: 3172257.5, y: 115445.205, z: undefined }, { x: 3166852.53, y: 74007.1163, z: undefined }, { x: 3169492.14, y: 74181.519, z: undefined }, { x: 3179462.24, y: 69364.1956, z: undefined }, { x: 3102245.8, y: 63493.7596, z: undefined }, { x: 3078008.19, y: 139849.388, z: undefined }, { x: 3159538.05, y: 134397.166, z: undefined }, { x: 3078264.18, y: 90791.7181, z: undefined }, { x: 3129496.59, y: 74162.1803, z: undefined }, { x: 3174460.63, y: 124792.718, z: undefined }, { x: 3135680.47, y: 95943.0124, z: undefined }, { x: 3087460.98, y: 55053.1302, z: undefined }, { x: 3147725.95, y: 137527.507, z: undefined }],
      pointTest: [{ "x": "3156554.34", "y": "129160.016", z: undefined }],
      map: null,
      markerList: []
    }
  },
  inject: ["getMap"],
  mounted() {
    this.getData()
  },
  methods: {
    handleClose() {
      this.drawer = false
    },
    delMakerTest() {
      console.log("清除标记点")
    },
    addMakerTest() {
      let _this = this
      if (this.isAddMarkers) return;
      this.isAddMarkers = true;
      let map = this.getMap();
      let mapBounds = map.getGeoBounds(); // 得到地图地理范围 
      // create the popup
      // let point = mapBounds.randomPoint(); // 在地理范围里随机生成一个点
      // 测试自定义make点位
      // let el = document.createElement('div');
      // el.className = 'marker';
      // el.style.backgroundImage =
      // 'url("static/img/main/zuo.png")';
      // el.style.width = '32px';
      // el.style.height = '32px';
      // el.style.backgroundSize = '100%';
      // new vjmap.Marker({
      // element: el,
      // anchor: 'bottom',
      // draggable: false
      // }).setLngLat(map.toLngLat(mapBounds.randomPoint())).addTo(map);
      for (let i = 0; i < _this.markerList.length; i++) {
        let el = document.createElement('div');

        if (_this.markerList[i].pointControlDataList.length == 2) {
          el.className = 'marker';
          /* el.style.backgroundImage =
            'url("static/img/jigui/005.png")'; */
        } else {
          el.className = 'marker1';
        }
        /* el.style.width = '20px';
        el.style.height = '20px'; */
        el.style.backgroundSize = '100%';
        let a = ''
        _this.markerList[i].pointControlDataList.forEach(item => {
          a += `<div>${item.description}:${item.value}${item.unit}</div>`
        })
        // 点位信息
        let position = _this.markerList[i].markerCoordinate
        let latLng = map.toLngLat(position);

        let popup = new vjmap.Popup({ closeOnClick: false, offset: 25 })
          .setHTML(`
    <iframe  id="testFrame" src="https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/G68365821/1.hd.live&autoplay=1&accessToken=at.dkx0xbr16wnd426ucv4b67n9920ruu4z-4g4577nxes-1ujiahd-wp4sfwylj&id=ysopen" width="100%" height="100%" allowfullscreen>
          </iframe>
    `);


        let marker = new vjmap.Marker({
          element: el,
          draggable: false,
          color: vjmap.randomColor()
        });
        // 点出文字效果
        marker.setLngLat(latLng).addTo(map);
        // 点出视频效果
        /* marker.setLngLat(map.getCenter())
          .setPopup(popup)
          .addTo(map);
        marker.togglePopup(); */

        marker.on('click', () => { this.showInfoOut(_this.markerList[i].controlNmae) });
        // 鼠标移入弹出框效果
        /*  marker.on('mouseover', (e) => {
                  if (!popup) {
                    popup = new vjmap.Popup({
                          className: "custom-popup",
                          closeButton: false,
                          offset: [0, -32]
                      });
                      popup.setLngLat(marker.getLngLat())
                          .setHTML(a)
                          .addTo(map);
                  }
              });   
              marker.on('mouseleave', (e) => {
                  if (popup) {
                      popup.remove();
                      popup = null;
                  }
      });  */
      }
    },
    addMarkers() {
      if (this.isAddMarkers) return;
      this.isAddMarkers = true;
      let map = this.getMap();
      let mapBounds = map.getGeoBounds(); // 得到地图地理范围
      // create the popup
      for (let i = 0; i < 15; i++) {
        let point = mapBounds.randomPoint(); // 在地理范围里随机生成一个点
        console.log(point)
        if (i < 5) {
          // marker
          /* let marker = new vjmap.Marker({
            draggable: true,
            color: vjmap.randomColor()
          });
          marker.setLngLat(map.toLngLat(point))
        marker.addTo(map); */
          // 前面5个弹出视频
          /* let popup = new vjmap.Popup({ closeOnClick: true, offset: 25 })
              .setHTML(`
              <video width="100%" height="100%"  controls="controls" autoplay="autoplay" muted loop>
                <source src="https://vjmap.com/static/assets/video/butterfly.mp4" type="video/mp4" />
              </video>
          `); */
          // marker.setPopup(popup);
        } else if (i < 10) {
          // 后面的弹出信息框
          // 通过设置className可更新默认样式
          /*   let marker = new vjmap.Marker({
              draggable: false,  // 控制是否可以拖动
              color: vjmap.randomColor()
            });
            marker.setLngLat(map.toLngLat(point))
            marker.addTo(map);
            let popup = new vjmap.Popup({ className:"custom-popup", closeOnClick: true, offset: 25 });
            popup.setHTML("Marker Index" + i);
            marker.setPopup(popup); */
        } else {
          // 用vue创建marker
          // 创建提示节点
          /* let prop = {
            title: "Marker" + i
          }
          let textMarker = new Vue({
            ...TextMarker,
            propsData: {
              prop
            }
          }).$mount();
          let marker = new vjmap.Marker({
            element: textMarker.$el
          });
          marker.setLngLat(map.toLngLat(point))
          marker.addTo(map); */
          if (i === 10) {
            // 把这个marker做个闪烁动画
            // marker.setAnimation("MAP_ANIMATION_BOUNCE");
          }
        }
      }
    },
    async addRoutes() {
      if (this.isAddRoute) return;
      this.isAddRoute = true;
      let map = this.getMap();
      let mapBounds = map.getGeoBounds(0.3);
      const routePath = [];
      // 随机加几个地图范围内的点
      routePath.push(mapBounds.min);
      routePath.push(mapBounds.center());
      routePath.push(vjmap.geoPoint([mapBounds.max.x, mapBounds.min.y]));
      routePath.push(mapBounds.max);
      routePath.push(vjmap.geoPoint([mapBounds.min.x, mapBounds.max.y]));
      routePath.push(mapBounds.min);

      // 路径线
      let routeLine = new vjmap.PolylineArrow({
        path: map.toLngLat(routePath),
        lineWidth: 10,
        showDir: true,
        lineColor: '#009EFF'
      });
      routeLine.addTo(map);
      // 实时动画轨迹线
      let realRoute = new vjmap.PolylineArrow({
        path: map.toLngLat(routePath),
        lineWidth: 10,
        showDir: true,
        showBorder: true,
        borderColor: "#f00",
        lineColor: '#FF9900'
      });
      realRoute.addTo(map);
      // 车图标
      await map.loadImageEx("carIcon", "./assets/car.png");
      // 车的数据源和图层
      map.addGeoJSONSource("carSource");
      map.addSymbolLayer("carAnimate", "carSource", {
        iconImage: 'carIcon',
        iconSize: 0.5,
        iconRotate: ['get', 'bearing'],
        iconRotationAlignment: 'map',
        iconAllowOverlap: true,
        iconIgnorePlacement: true
      })
      // 线动画
      const anim = realRoute.animate(100, 10, true, status => console.log(status), (status, context) => {
        // 动画每帧回调，在这里可以实时改变车的位置
        // 获取角度
        const angle = vjmap.geoPoint(context.endPnt).angleTo(vjmap.geoPoint(context.startPnt));
        // 生成新的数据
        const carGeoJson = vjmap.createPointGeoJson({
          point: context.endPnt,
          properties: { bearing: vjmap.radToDeg(-angle) }
        });
        // 更新车的数据
        map.setData("carSource", carGeoJson); // 更新位置
      })
      setTimeout(() => anim.stop(), 120 * 1000);//两分钟后停止
    },
    vectorStyleFillExtrusion() {
      if (this.isFillExtrusion) return;
      this.isFillExtrusion = true;
      let map = this.getMap();
      let mapBounds = map.getGeoBounds();
      const len = mapBounds.width() / 40;
      const darkMode = true;
      // 反色设置
      const darkColor = [
        "case",
        ["==", ["get", "color"], "#000000"],
        "#FFFFFF",
        ["get", "color"]
      ];

      const color = [
        "case",
        ["boolean", ["feature-state", "hover"], false],
        "rgba(0,0,255,255)",
        darkMode ? darkColor : ["get", "color"]
      ];

      // 拉伸图层
      map.addFillExtrusionLayer("vector-layer-polygons", "vector-source", {
        source: "vector-source",
        sourceLayer: "polygons",
        fillExtrusionColor: color,
        fillExtrusionBase: 0,
        fillExtrusionHeight: map.getProjection().toMeter(len)
      })

      map.flyTo({
        pitch: 60
      });
    },
    async vectorStyleQueryAddMesh() {
      if (this.isAddMesh) return;
      this.isAddMesh = true;
      let map = this.getMap();
      // 限制地图范围为全图范围，防止多屏地图显示
      this.$nextTick(functiom)
      map.setMaxBounds(map.toLngLat(map.getProjection().getMapExtent()));

      // 下面增加deck的图层
      if (typeof deck !== "object") {
        // 如果没有deck环境
        await vjmap.addScript([{
          src: "https://vjmap.com/demo/js/deck.gl.min.js"
        }, {
          src: "https://vjmap.com/demo/js/loaders.gl/core/dist/dist.min.js"
        }, {
          src: "https://vjmap.com/demo/js/loaders.gl/obj/dist/dist.min.js"
        }]);
        // 注册加载
        // eslint-disable-next-line no-undef
        loaders.registerLoaders([loaders.OBJLoader]);
      }
      const sourceId = "vector-source";
      // 等待数据源加载完成
      const waitSourceLoaded = () => {
        return new Promise((resolve) => {
          const lister = () => {
            if (map.getSource(sourceId) && map.isSourceLoaded(sourceId)) {
              map.off("sourcedata", lister);
              resolve({});
            }
          };
          map.on("sourcedata", lister);
        });
      }

      await waitSourceLoaded();

      // 实体类型ID和名称映射
      const { entTypeIdMap } = await map.getService().getConstData();
      // 查询0图层实体类型为圆的所有实体
      const featureType = "AcDbCircle";
      const featureTypeIndex = Object.keys(entTypeIdMap).find(e => entTypeIdMap[e] === featureType); // 结果为7
      const features = map.querySourceFeatures(sourceId, { sourceLayer: "lines", filter: ["all", ["==", "layer", 0], ["==", "type", +featureTypeIndex]] });
      // 得到查询到的实体的中心点
      const points = features.map(f => {
        const geom = f.geometry.coordinates;
        const pt = vjmap.GeoBounds.fromDataExtent(geom).center(); // 得到中心点
        return [pt.x, pt.y];
      });

      const data = [];
      for (let i = 0; i < points.length; i++) {
        data.push({
          id: i + 1,
          position: points[i],
          color: [vjmap.randInt(0, 255), vjmap.randInt(0, 255), vjmap.randInt(0, 255)],
          angle: vjmap.randInt(0, 360)
        })
      }

      const deckLayer = new vjmap.DeckLayer({
        id: 'scatterplot',
        // eslint-disable-next-line no-undef
        type: deck.SimpleMeshLayer,
        data: data,
        getPosition: d => d.position,
        mesh: "./assets/Bulbasaur.obj",
        getColor: d => d.color,
        getOrientation: d => [0, d.angle, 90],
        sizeScale: 40000,
        autoHighlight: true,
        pickable: true,
        onClick: ({ object }) => {
          console.log(`您点击了 Deck图层中的 第 ${object.id} 个对象`)
        }
      });
      map.addLayer(deckLayer);

      map.flyTo({ center: [-61.59, 13.28], zoom: 4, pitch: 58, bearing: 112 });
    },
    showInfoM() {
      console.log("点击覆盖物")
    },
    showInfoOver() {
      console.log("移入覆盖物")
    },
    showInfoOut(val) {
      this.$emit("getReply", val)
      /* let pt = this.map.fromLngLat(this.marker.getLngLat());
       alert(pt.toString(2)) */
    },
    // 获取数据源
    getData() {
      let that = this
      let interList = [
        {
          intName: 'F1ICU1环境数据接口',
          controlNmae: 'F1ICU1控制数据接口',
          makerPoint: { x: 66277.520, y: 68129.756, z: 0 }
        },
        {
          intName: 'F1ICU2环境数据接口',
          controlNmae: 'F1ICU2控制数据接口',
          makerPoint: { x: 3147725.95, y: 137527.507, z: 0 }
        },
        {
          intName: 'F1ICU3环境数据接口',
          controlNmae: 'F1ICU3控制数据接口',
          makerPoint: { x: 3159538.05, y: 134397.166, z: 0 }
        },
        {
          intName: 'F1ICU4环境数据接口',
          controlNmae: 'F1ICU4控制数据接口',
          makerPoint: { x: 3156554.34, y: 129160.016, z: 0 }
        },
        {
          intName: 'F1ICU7环境数据接口',
          controlNmae: 'F1ICU7控制数据接口',
          makerPoint: { x: 3167784.16, y: 120919.343, z: 0 }
        },
        {
          intName: 'F1ICU8环境数据接口',
          controlNmae: 'F1ICU8控制数据接口',
          makerPoint: { x: 3172257.5, y: 115445.205, z: 0 }
        },
        {
          intName: 'F1ICU10环境数据接口',
          controlNmae: 'F1ICU10控制数据接口',
          makerPoint: { x: 3166852.53, y: 74007.1163, z: 0 }
        },
        {
          intName: 'F1ICU11环境数据接口',
          controlNmae: 'F1ICU11控制数据接口',
          makerPoint: { x: 3169492.14, y: 74181.519, z: 0 }
        },
        {
          intName: 'F1ICU12环境数据接口',
          controlNmae: 'F1ICU12控制数据接口',
          makerPoint: { x: 3179462.24, y: 69364.1956, z: 0 }
        },
        {
          intName: 'F1ICU13环境数据接口',
          controlNmae: 'F1ICU13控制数据接口',
          makerPoint: { x: 3102245.8, y: 63493.7596, z: 0 }
        },
        {
          intName: 'F1ICU17环境数据接口',
          controlNmae: 'F1ICU17控制数据接口',
          makerPoint: { x: 3078264.18, y: 90791.7181, z: 0 }
        },
        {
          intName: 'F1ICU19环境数据接口',
          controlNmae: 'F1ICU19控制数据接口',
          makerPoint: { x: 3174460.63, y: 124792.718, z: 0 }
        },
        {
          intName: 'F1ICU20环境数据接口',
          controlNmae: 'F1ICU20控制数据接口',
          makerPoint: { x: 3129496.59, y: 74162.1803, z: 0 }
        },
        {
          intName: 'F1ICU14环境数据接口',
          controlNmae: 'F1ICU14控制数据接口',
          makerPoint: { x: 3135680.47, y: 95943.0124, z: 0 }
        },
      ]
      for (let i = 0; i < interList.length; i++) {
        let obj = {
          args: [interList[i].intName]
        }
        let ponitObj = {
          controlNmae: interList[i].controlNmae,
          interName: interList[i].intName,
          markerCoordinate: interList[i].makerPoint,
          pointControlDataList: [],
        }
        service.getPublicData(obj).then(res => {
          ponitObj.pointControlDataList = [...res]
          this.markerList.push(ponitObj)
        }).catch(err => {
          console.log(err)
        })
      }
      setTimeout(() => {
        that.addMakerTest()
      }, 2000)

    },
    // 修改数据
  }

}
</script>

<style>
.marker {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  /* -webkit-animation: ripple .7s linear infinite;
  animation: ripple .7s linear infinite; */
  /* background-color: #8dca67; */
  background-image: url('../../../static/img/diy/04.png');
}

.marker1 {
  width: 20px;
  height: 20px;
  /* background-image: url('../../../static/img/jigui/005.png');
  background-size: 100% 100%; */
  border-radius: 50%;
  /* -webkit-animation: ripple1 .7s linear infinite;
  animation: ripple1 .7s linear infinite; */
  /*  background-color: #ca6767; */
  background-image: url('../../../static/img/diy/04.png');
}

@-webkit-keyframes ripple {
  0% {
    box-shadow: 0 0 0 0 rgba(101, 255, 120, 0.3), 0 0 0 1px rgba(101, 255, 120, 0.3), 0 0 0 5px rgba(101, 255, 120, 0.3), 0 0 0 7px rgba(101, 255, 120, 0.3)
  }

  100% {
    box-shadow: 0 0 0 1px rgba(101, 255, 120, 0.3), 0 0 0 5px rgba(101, 255, 120, 0.3), 0 0 0 7px rgba(101, 255, 120, 0.3), 0 0 0 10px rgba(101, 255, 120, 0)
  }
}

@keyframes ripple {
  0% {
    box-shadow: 0 0 0 0 rgba(101, 255, 120, 0.3), 0 0 0 1px rgba(101, 255, 120, 0.3), 0 0 0 5px rgba(101, 255, 120, 0.3), 0 0 0 7px rgba(101, 255, 120, 0.3)
  }

  100% {
    box-shadow: 0 0 0 1px rgba(101, 255, 120, 0.3), 0 0 0 5px rgba(101, 255, 120, 0.3), 0 0 0 7px rgba(101, 255, 120, 0.3), 0 0 0 10px rgba(101, 255, 120, 0)
  }
}

@-webkit-keyframes ripple1 {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 101, 101, 0.3), 0 0 0 1px rgba(255, 101, 101, 0.3), 0 0 0 5px rgba(255, 101, 101, 0.3), 0 0 0 7px rgba(255, 101, 101, 0.3)
  }

  100% {
    box-shadow: 0 0 0 1px rgba(255, 101, 101, 0.3), 0 0 0 5px rgba(255, 101, 101, 0.3), 0 0 0 7px rgba(255, 101, 101, 0.3), 0 0 0 10px rgba(101, 255, 120, 0)
  }
}

@keyframes ripple1 {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 101, 101, 0.3), 0 0 0 1px rgba(255, 101, 101, 0.3), 0 0 0 5px rgba(255, 101, 101, 0.3), 0 0 0 7px rgba(255, 101, 101, 0.3)
  }

  100% {
    box-shadow: 0 0 0 1px rgba(255, 101, 101, 0.3), 0 0 0 5px rgba(255, 101, 101, 0.3), 0 0 0 7px rgba(255, 101, 101, 0.3), 0 0 0 10px rgba(101, 255, 120, 0)
  }
}

.custom-popup .vjmapgis-popup-content {
  background-color: #433f3fb2;
  color: #8dca67;
}

.custom-popup .vjmapgis-popup-tip {
  border-top-color: #777977;
}

.input-card {
  display: flex;
  flex-direction: column;
  min-width: 276px;
  overflow-wrap: break-word;
  background-color: transparent;
  background-clip: border-box;
  min-height: 64px;
  border-width: 0px;
  border-radius: 2px;
  box-shadow: transparent 0px 2px 6px 0px;
  position: fixed;
  bottom: 10px;
  right: 50px;
  flex: 1 1 auto;
  padding: 12px;
}

.input-card>li {
  list-style: none;
}

.input-item {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
}


.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 1px solid rgb(0, 55, 228);
  transition: color 0.15s ease-in-out 0s, background-color 0.15s ease-in-out 0s, border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
  background-color: transparent;
  background-image: none;
  color: rgb(0, 55, 228);
  line-height: 1.5;
  border-radius: 4px;
  appearance: button;
  cursor: pointer;
  min-width: 120px;
  min-height: 36px;
  box-sizing: border-box;
  font-size: 14px;
  margin-right: 8px;
  margin-top: 8px;
  margin-left: 18px;
}

.btn:nth-child(2n) {
  margin-right: 0px;
}

.btn-active {
  color: rgb(255, 255, 255);
  background-color: rgb(0, 55, 228);
  border-color: rgb(0, 55, 228);
}

.mr0 {
  margin-right: 0px;
}

.btn-full {
  width: 100%;
}

.btn:hover {
  color: rgb(255, 255, 255);
  background-color: rgb(0, 55, 228);
  border-color: rgb(0, 55, 228);
}

.btn:hover {
  text-decoration: none;

}
</style>


// WEBPACK FOOTER //
// src/components/vjmapUtil/ToolBar.vue